module.exports = __webpack_public_path__ + "img/data1-1.6dbb0bc1.png";